import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Box, Button, Container, Typography } from '@mui/material'

import TrackingLine from '../../../../../ui/modules/TrackingLine'
import useTranslations from '../../../../../i18n/useTranslations'
import styles from '../../styles'
import ActivateReturnDrawer from '../../../../../App/ShippingsTracking/ActivateReturnDrawer'

const TrackingSectionDesktop = ({
  data,
  trackingLineData,
  showFullTrackingButton,
  cancelActivateReturn,
  activateReturnShippingInfo,
  onOpenFullTrackingDrawer,
}) => {
  const t = useTranslations()
  return (
    <>
      <Box component="section" sx={styles.section}>
        <Container sx={styles.mainContainer}>
          <Box sx={styles.titleContainer}>
            <Box sx={styles.titleWrapper}>
              <Typography
                variant="h2"
                className={clsx('secondaryTitle', 'decorator')}
                sx={styles.title}
              >
                {t('shipping-tracking:tracking')}
              </Typography>
            </Box>
            <Box sx={styles.fakeGap} aria-hidden="true" />
            <Box sx={styles.fakeGap} aria-hidden="true" />
            <Box sx={styles.fakeGap} aria-hidden="true" />
            <Box sx={styles.fakeGap} aria-hidden="true" />
          </Box>
          {Boolean(trackingLineData) && (
            <TrackingLine
              {...trackingLineData}
              showSeeReturn={true}
              isShippingDetail
              shippingInfo={data.info}
              shippingDates={{
                recordDate: data.info.manifestedDate,
                deliveryDate: data.info.committedDeliveryDatetime,
              }}
              shippingStatusCode={
                data.info?.lastShippingStatusCode?.lastStatusCode ??
                data.info?.shippingStatusCode?.code
              }
              addresses={{ from: data.from, to: data.to }}
            />
          )}
          {showFullTrackingButton ? (
            <Box sx={styles.buttonContainer}>
              <Box sx={styles.buttonWrapper}>
                <Button
                  size="small"
                  onClick={onOpenFullTrackingDrawer}
                  variant="outlined"
                  sx={styles.fullTrackingButton}
                >
                  {t('shipping-tracking:see-complete-tracking')}
                </Button>
              </Box>
              <Box sx={styles.fakeGap} aria-hidden="true" />
              <Box sx={styles.fakeGap} aria-hidden="true" />
              <Box sx={styles.fakeGap} aria-hidden="true" />
              <Box sx={styles.fakeGap} aria-hidden="true" />
            </Box>
          ) : null}
        </Container>
      </Box>
      <ActivateReturnDrawer
        activateReturnShippingInfo={activateReturnShippingInfo}
        onClickClose={cancelActivateReturn}
      />
    </>
  )
}

TrackingSectionDesktop.propTypes = {
  data: PropTypes.object,
  trackingLineData: PropTypes.object,
  cancelActivateReturn: PropTypes.func,
  activateReturnShippingInfo: PropTypes.object,
  showFullTrackingButton: PropTypes.bool,
  onOpenFullTrackingDrawer: PropTypes.func,
}

export default TrackingSectionDesktop
